import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm, useNotify } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { errorMessages } from "app";
import EditForm from "./EditForm";

const EditTrainingBases = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  return (
    <>
      <Edit
        title="Редакция на учебна база"
        actions={<BackButtonToolbar />}
        mutationMode="pessimistic"
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
      >
        <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
          <EditForm />
        </SimpleForm>
      </Edit>
      <ConflictErrorDialog />
    </>
  );
};

export default EditTrainingBases;
